import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, lifecycle, withProps } from 'recompose';
import { products as productsAPI } from 'api';
import reducers, { getIsFetching, getProduct } from './reducers';
import { resetProductApiHOC } from './actions';

const ProductApiHOC = ({ getProductId }) => WrappedComponent => compose(
  connect(
    state => ({
      _productApiHOC_state: {
        product: getProduct(state),
        isProductFetching: getIsFetching(state),
      },
    }),

    dispatch => ({
      _productApiHOC_actions: {
        getProduct: bindActionCreators(productsAPI.actions.getProduct, dispatch),
        resetProduct: bindActionCreators(resetProductApiHOC, dispatch),
      },
    }),
  ),

  /* eslint-disable no-underscore-dangle */
  withProps(
    props => ({
      productApiHOC: {
        ...props._productApiHOC_state,
        ...props._productApiHOC_actions,
      },
    }),
  ),
  /* eslint-enable no-underscore-dangle */

  lifecycle({
    componentWillReceiveProps(nextProps) {
      const currentProductId = getProductId(this.props);
      const productId = getProductId(nextProps);

      if (productId && productId !== currentProductId) {
        this.props.productApiHOC.resetProduct();
        this.props.productApiHOC.getProduct(productId);
      }
    },

    componentDidMount() {
      this.props.productApiHOC.getProduct(getProductId(this.props));
    },

    componentWillUnmount() {
      this.props.productApiHOC.resetProduct();
    },
  }),
)(WrappedComponent);

export { reducers };

export default ProductApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductApiHOC/index.js